import React, { Component } from 'react';

import AuthService from '../../state/auth.service';

import UserApi from '../../api/user';
import Button from '../form/Button';
import Message from '../form/Message';
import PhoneNumber from './PhoneNumber';

class AccountManagerForm extends Component {
    constructor(props, context) {
        super(props, context);

        let name = '';
        let phone = '';
        const user = AuthService.getUser();

        if (user) {
            name = user.name || '';
            phone = user.phone || '';
        }

        this.state = {
            name: name,
            phone: phone,
            isbusy: false,
            errorMessage: null,
            successMessage: null,
        };

        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.validateForm = this.validateForm.bind(this);
    }

    onChange(evt) {
        let changes = {};
        changes[evt.target.name] = evt.target.value;
        this.setState(changes);
    }

    componentDidMount() {
        UserApi.getLoggedInUser()
            .then(data => {
                this.setState({
                    name: data.name,
                    phone: data.phone_number,
                });
            })
            .catch(err => {
                console.error(err);
            });
    }

    refreshUser() {}

    validateForm() {
        const { name, phone } = this.state;

        let phoneNumber = PhoneNumber.format(phone);
        if (name.length < 1) {
            this.setState({ errorMessage: 'Please enter your name.' });
            return false;
        } else if (phoneNumber.length < 12) {
            this.setState({
                errorMessage:
                    'Please enter your phone number in the format (222) 333-4444',
            });
            return false;
        }

        return true;
    }

    onFormSubmit(event) {
        event.preventDefault();

        this.setState(
            { errorMessage: null, successMessage: null, isbusy: true },
            () => {
                const isValid = this.validateForm();

                if (!isValid) {
                    this.setState({ isbusy: false });
                    return;
                }
                let phoneNumber = PhoneNumber.format(this.state.phone);
                UserApi.update(this.state.name, phoneNumber)
                    .then(() => {
                        let savedUser = AuthService.getUser();
                        let updatedUser = Object.assign({}, savedUser, {
                            name: this.state.name,
                            phone: phoneNumber,
                        });
                        console.log(
                            'Updating user to ' +
                                JSON.stringify(updatedUser, null, '    ')
                        );
                        AuthService.setUser(updatedUser);
                        this.setState({
                            successMessage: 'Updates saved.',
                            isbusy: false,
                        });
                    })
                    .catch(errorMessage => {
                        this.setState({
                            errorMessage: errorMessage,
                            isbusy: false,
                        });
                    });
            }
        );
    }

    render() {
        return (
            <form onSubmit={this.onFormSubmit}>
                <div className="form__field">
                    <label htmlFor="name">Name</label>
                    <input
                        type="text"
                        name="name"
                        value={this.state.name}
                        onChange={this.onChange}
                    />
                </div>

                <div className="form__field">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                        type="text"
                        name="phone"
                        value={this.state.phone}
                        onChange={this.onChange}
                    />
                </div>

                <div className="form__buttons">
                    <Button
                        type="submit"
                        defaultText="Update account"
                        busyText="Updating account"
                        isbusy={this.state.isbusy}
                    />
                </div>

                <div className="form__footer">
                    <Message
                        error={this.state.errorMessage}
                        success={this.state.successMessage}
                    />
                </div>
            </form>
        );
    }
}

export default AccountManagerForm;
